var map = {
	"./1.png": "Z69R",
	"./2.png": "Ee/F",
	"./3.png": "xZSO",
	"./4.png": "zWF/",
	"./5.png": "+Lao",
	"./6.png": "aCVA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+zqu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product ^\.\/.*\.png$
// module id = +zqu
// module chunks = 1